import { render, staticRenderFns } from "./inactiveDetailModal.vue?vue&type=template&id=393c3c57&scoped=true&"
import script from "./inactiveDetailModal.vue?vue&type=script&lang=js&"
export * from "./inactiveDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./inactiveDetailModal.vue?vue&type=style&index=0&id=393c3c57&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393c3c57",
  null
  
)

export default component.exports